const PipelineConfig = {
  project: {
    getAll:      "/pipeline/project/",
    show:        "/pipeline/project/show/",
    new:         "/pipeline/project/",
    edit:        "/pipeline/project/edit",
    delete:      "/pipeline/project/delete/",
    addContact:  "/pipeline/project/",
    filePreview: "/pipeline/project/logo/",
  },
  step: {
    byProject: "/pipeline/step/project/",
    new:       "/pipeline/step/",
    edit:      "/pipeline/step/edit",
    delete:    "/pipeline/step/delete/",
    reorder:   "/pipeline/step/reorder/",
  },
  entry: {
    byProject: "/pipeline/entry/project/",
    new:       "/pipeline/entry/",
    edit:      "/pipeline/entry/edit",
    delete:    "/pipeline/entry/delete/",
  },
};

export default PipelineConfig;
